import Nav from "./../Page/Share/Nav/Nav";
const Post11 = () => {
  return (
    <div>
      <div className="container">
        <Nav></Nav>

        <div className="infowork">
          {/* items Title} */}
          <h2>
            Ikshana Brand Identity Design
          </h2>
          {/* items?.Description */}
          <p>

          </p>
          {/* img section */}
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/1400_opt_1/668035133441343.61bd6bb457740.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/889642133441343.61bd6bb4a66ed.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/9a7fbc133441343.61bd6bb4a7378.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/69015f133441343.61bd6bb4a5f7e.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/b1b686133441343.61bd6bb4a6e6d.jpg" alt="" />
          <img src="https://cdn.dribbble.com/users/6827497/screenshots/17933580/media/432721c8173b717988cf3ef1a1b7466e.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/96e974133441343.61bd6bb4a50e2.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/071c3d133441343.61bd6bb4a5949.jpg" alt="" />
          <p>

          </p>
        </div>
      </div>
    </div>
  );
};

export default Post11;
